import { render } from "./Header.vue?vue&type=template&id=c62dc380&bindings={\"first\":\"props\",\"second\":\"props\",\"number\":\"props\",\"smallcaps\":\"props\",\"blue\":\"props\",\"id\":\"options\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script